module.exports = __webpack_public_path__ + "img/2311.1b07a5b4.png";